import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import React from 'react';
import { actionTypes, createActions } from '../gamePlanType';

export const GuidanceSection = (): JSX.Element => {
    return (
        <Card style={{ width: '338px', borderRadius: '30px' }}>
            <div style={{ padding: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                    <i
                        className="pi pi-chevron-down"
                        style={{ fontSize: '24px', color: 'var(--medium-steel)' }}
                    />
                    <h2
                        style={{
                            marginLeft: '24px',
                            fontWeight: 'bold',
                            fontSize: '24px',
                            color: 'var(--medium-steel)',
                            fontFamily: 'Urbanist',
                        }}
                    >
                        Guidance
                    </h2>
                </div>

                <Divider style={{ marginBottom: '24px' }} />

                <h3
                    style={{
                        fontWeight: 'bold',
                        fontSize: '18px',
                        color: 'var(--medium-steel)',
                        fontFamily: 'Urbanist',
                        marginBottom: '16px',
                    }}
                >
                    Action
                </h3>

                {actionTypes.map((action) => (
                    <div key={action.id} style={{ marginBottom: '32px' }}>
                        <div style={{ position: 'relative', height: '30px' }}>
                            <img
                                style={{
                                    position: 'absolute',
                                    width: '14px',
                                    height: '13px',
                                    top: '17px',
                                    left: 0,
                                }}
                                alt="Vector"
                                src={action.vectorIcon}
                            />
                            <Button
                                style={{
                                    backgroundColor: action.bgColor,
                                    height: '29px',
                                    padding: '4px 8px',
                                    borderRadius: '8px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    width: '130px',
                                    cursor: 'default',
                                }}
                            >
                                <img
                                    style={{ width: '18px', height: '15px' }}
                                    alt={action.name}
                                    src={action.icon}
                                />
                                <span style={{ color: 'white', fontWeight: 'bold' }}>{action.name}</span>
                            </Button>
                        </div>
                        <div
                            style={{
                                marginLeft: '51px',
                                marginTop: '12px',
                                fontFamily: 'Urbanist',
                                color: 'var(--medium-steel)',
                                fontSize: '16px',
                            }}
                        >
                            {action.description}
                        </div>
                    </div>
                ))}

                <Divider style={{ margin: '24px 0' }} />

                <h3
                    style={{
                        fontWeight: 'bold',
                        fontSize: '18px',
                        color: 'var(--medium-steel)',
                        fontFamily: 'Urbanist',
                        marginBottom: '16px',
                    }}
                >
                    Create
                </h3>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                    <i className="pi pi-plus-circle" style={{ fontSize: '24px' }} />
                    <span
                        style={{
                            marginLeft: '12px',
                            fontFamily: 'Urbanist',
                            color: 'var(--medium-steel)',
                            fontSize: '16px',
                        }}
                    >
                        Create new action
                    </span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
                    <i className="pi pi-eye" style={{ fontSize: '24px' }} />
                    <span
                        style={{
                            marginLeft: '12px',
                            fontFamily: 'Urbanist',
                            color: 'var(--medium-steel)',
                            fontSize: '16px',
                        }}
                    >
                        Review created action
                    </span>
                </div>

                {createActions.map((action) => (
                    <div key={action.id} style={{ marginBottom: '24px' }}>
                        <Button
                            className="p-button-outlined"
                            style={{
                                height: 'auto',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '6px 12px',
                                borderRadius: '30px',
                                borderColor: action.borderColor,
                                color: action.textColor,
                                width: '160px',
                                cursor: 'default',
                            }}
                        >
                            <i className="pi pi-plus-circle" />
                            <Divider
                                style={{
                                    height: '21px',
                                    margin: '0 0px',
                                    width: '30px',
                                    transform: 'rotate(270deg)',
                                }}
                            />
                            <span style={{ fontWeight: 600 }}>{action.name}</span>
                        </Button>
                        <div
                            style={{
                                marginLeft: '51px',
                                marginTop: '12px',
                                fontFamily: 'Urbanist',
                                color: 'var(--medium-steel)',
                                fontSize: '16px',
                            }}
                        >
                            {action.description}
                        </div>
                    </div>
                ))}
            </div>
        </Card>
    );
};
